// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '3915ebf816f68efebdf2c750f479069822e445eb';
export const BUILD_NUMBER = '218';
export const BUILD_TIMESTAMP = '2026-08-20T06:54:01.234Z';
